import { useEffect, useState } from "react";
import { Bell, DollarSign, AlertTriangle, RotateCcw, CalendarDays, ListChecks } from "lucide-react";
import api from "@/lib/api";

const ICON = { dollar: DollarSign, alert: AlertTriangle, refund: RotateCcw, calendar: CalendarDays, list: ListChecks };

export default function Notifications() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/notifications").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div data-testid="notifications-page">
      <h1 className="font-display text-4xl flex items-center gap-2"><Bell className="w-7 h-7 text-brand-red" /> Notifications</h1>
      <p className="text-brand-ink/60 dark:text-white/50 mt-2">Recent activity across bookings, payments, refunds and waitlist.</p>
      <div className="mt-8 space-y-2">
        {!items ? <div className="text-brand-ink/50">Loading…</div> : items.length === 0 ? <div className="text-brand-ink/50 dark:text-white/40" data-testid="notifications-empty">Nothing new yet.</div> : items.map((n, i) => {
          const I = ICON[n.icon] || Bell;
          return (
            <div key={i} className="bg-white dark:bg-neutral-900 border border-brand-line dark:border-neutral-800 rounded-xl px-5 py-3.5 flex items-center gap-3" data-testid={`notif-${i}`}>
              <I className="w-5 h-5 text-brand-red shrink-0" />
              <div className="flex-1 text-sm">{n.text}</div>
              <div className="text-xs text-brand-ink/40 dark:text-white/40">{(n.at || "").slice(0, 16).replace("T", " ")}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
